import { memo, useCallback, useState } from 'react';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { Box, Button, ScrollView, Text } from '@betty/moonlight';
import { PaymentMethodVerificationNavigatorParamsList } from '../../../navigators/PaymentMethodVerificationNavigator/PaymentMethodVerificationNavigator.types';
import { PaymentEntityId } from '../../../state/payment/payment.types';
import PaymentMethodVerificationCardsSkeleton from './PaymentMethodVerificationCardsSkeleton';
import PaymentMethodVerificationCard from './PaymentMethodVerificationCard/PaymentMethodVerificationCard';
import useUnverifiedPaymentMethods from '../../../hooks/useUnverifiedPaymentMethods';

function PaymentMethodVerificationCards() {
  const navigation =
    useNavigation<
      StackNavigationProp<PaymentMethodVerificationNavigatorParamsList>
    >();
  const { data } = useUnverifiedPaymentMethods();
  const [paymentEntityId, setPaymentEntityId] = useState<PaymentEntityId>();
  const hasMultiplePayments = data && data.length > 1;

  const onContinue = useCallback(() => {
    if (!paymentEntityId) {
      return;
    }

    navigation.navigate('PaymentMethodVerificationImagesScreen', {
      paymentEntityId,
      hasMultiplePayments,
    });
  }, [paymentEntityId, hasMultiplePayments, navigation]);

  if (!data) {
    return <PaymentMethodVerificationCardsSkeleton />;
  }

  return (
    <ScrollView
      contentContainerStyle={{
        paddingTop: 'space-400',
        paddingBottom: 'safe-area-inset-bottom',
        paddingHorizontal: 'space-600',
        minHeight: '100%',
      }}
    >
      <Text
        variant="h5"
        locNS="wallet"
        locKey="paymentMethodVerificationCardsTitle"
        color="darkSurfacePrimary"
        textAlign="center"
      />
      <Box gap="space-200" paddingVertical="space-400">
        {data.map((card) => (
          <PaymentMethodVerificationCard
            key={card.paymentEntityId}
            selected={card.paymentEntityId === paymentEntityId}
            onSelect={setPaymentEntityId}
            {...card}
          />
        ))}
      </Box>
      <Box flex={1} justifyContent="flex-end" gap="space-400">
        <Button
          locNS="common"
          locKey="continue"
          size="large"
          disabled={!paymentEntityId}
          onPress={onContinue}
        />
        <Button
          variant="secondary"
          locNS="common"
          locKey="goBack"
          size="large"
          onPress={navigation.goBack}
        />
      </Box>
    </ScrollView>
  );
}

export default memo(PaymentMethodVerificationCards);
